import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', 
        display: 'flex', 
        flexDirection: 'column', 
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 18, 
        borderBottom: '1px solid rgba(0,0,0,.3)', 
        width: '100%', 
        textAlign: 'center', 
        padding: '20px 0'
    },
    date: {
        position: 'absolute', 
        top: 10, 
        left: 10, 
        fontSize: 14, 
        color: '#14c0e9'
    },
    read: {
        position: 'absolute', 
        top: 10, 
        right: 10, 
        borderRadius: '50%', 
        background: 'rgba(255,255,255,0.2)', 
        padding: '5px 10px 5px', 
        fontSize: 14, 
        color: '#ff4e44', 
        fontWeight: 700
    },
    message: {
        color: '#f1f1f1', 
        fontSize: 16, 
        padding: '0 20px',
        textAlign: 'justify'
    },
    mt12: {
        marginTop: 12
    }
}))

const getDate = (value) => {
    const date = new Date(moment.utc(+value));

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const min = date.getMinutes();

    const formatterDay = day < 10 ? '0' + day : day;
    const formatterMonth = month < 10 ? '0' + month : month;
    const formatterHours = hours < 10 ? '0' + hours : hours;
    const formatterMinutes = min < 10 ? '0' + min : min;
    
    return `${formatterDay}.${formatterMonth}.${year} ${formatterHours}:${formatterMinutes}`
}


const getMessageText = (message, view) => {
    return message.length > 100 && !view ? message.slice(0, 90) + '...' : message
}

export {
    getDate,
    getMessageText, 
    useStyles
}